// mui components
import { Box, Stack } from "@mui/material";

// custom components
import CustomAlert from "../../components/custom-alert";
import NewQuickPricer from "../../components/quick-pricer-form";
import QuickPricerFooter from "./components/QuickPricerFooter";

// assets
import LoganLogo from "../../assets/img/dashboard-logo.png";

// constants
import { VERBIAGE_CONSTANTS } from "../../utils/verbiage.constants";

// custom styles
import styles from "./index.module.scss";

// Standalone Quick Pricer -- no left-nav, no CustomLayout (has its own logo
// header and copyright footer instead, unlike the authenticated /quick-pricer
// route, which shows neither).
// Reuses the existing authenticated NewQuickPricer component unmodified.
export default function PublicQuickPricer() {
	return (
		<Box className={styles.pageContainer}>
			<Box className={styles.header}>
				<img src={LoganLogo} alt="Logan Finance" />
			</Box>

			<Stack className={styles.bodyContainer}>
				<CustomAlert
					severity="info"
					details={VERBIAGE_CONSTANTS.QUICK_PRICER_PUBLIC_DISCLAIMER}
				/>

				<NewQuickPricer isPublic />
			</Stack>

			<QuickPricerFooter />
		</Box>
	);
}
